import { PauseCircleFilled } from '@material-ui/icons'
import React from 'react'

import { AudioButton } from './styles'

export default function Play(props) {
    const { handleClick } = props

    return (
        <AudioButton className="player__button" onClick={() => handleClick()}>
            <PauseCircleFilled />
        </AudioButton>
    )
}
